import { readCookieValue } from '../composables/api'

export const useUserPref = defineStore('useUserPref', {
  state: () => {
    // const localeCookie = useCookie('locale')
    // const preferredServiceCateCookie = useCookie('preferredServiceCate')
    // const showEditorsCookie = useCookie('showEditors')
    return {
      locale: readCookieValue('locale', ''),
      preferredServiceCate: readCookieValue('preferredServiceCate', ''),
      showEditors: String(readCookieValue('showEditors', 'false')) === 'true',
      showAdminPanel: String(readCookieValue('showAdminPanel', 'false')) === 'true',
      workspaceMode: String(readCookieValue('workspaceMode', 'false')) === 'true'
    }
  },
  actions: {
    setLocale(locale: string) {
      const localeCookie = useCookie('locale')
      localeCookie.value = locale
      this.locale = locale
      useUser().setPreferences({ language: locale }).catch(e => console.error('saving pref.language failed:', e))
    },
    setPreferredServiceCate(cate: ServiceCate) {
      const preferredServiceCateCookie = useCookie('preferredServiceCate')
      preferredServiceCateCookie.value = cate
      this.preferredServiceCate = cate
      console.log('preferredServiceCate is now', this.preferredServiceCate)
    },
    showOrHideEditors() {
      // console.log('showEditors:', this.showEditors)
      this.showEditors = !this.showEditors
      // console.log('showEditors is now:', this.showEditors)
      const showEditorsCookie = useCookie('showEditors')
      showEditorsCookie.value = String(this.showEditors)
    },
    showOrHideAdminPanel() {
      this.showAdminPanel = !this.showAdminPanel
      const showAdminPanelCookie = useCookie('showAdminPanel')
      showAdminPanelCookie.value = String(this.showAdminPanel)
    },
    switchWorkspaceMode() {
      this.workspaceMode = !this.workspaceMode
      const workspaceModeCookie = useCookie('workspaceMode')
      workspaceModeCookie.value = String(this.workspaceMode)
    }
  }
})
